export default ngModule => {

  /**
   * Directive to handle magic on feature labels on comparator page.
   *
   * We want to offset the label when not on mobile so it sits to the left of the first column
   *
   * We also want to adjust padding based on wrapping - if text goes across multilines get rid of padding, otherwise
   * retain it. This gives the effect of vertically centering.
   **/
  ngModule.directive('featureLabel', ($log, matchmedia, $timeout) => {
    return {
      restrict: 'A',
      link: (scope, element, attrs) => {
        const parent = element.parent(),
          padding = parseInt(parent.css('padding-right').replace('px', '')),
          width = parent.width();

        let hasApplied = false;

        // Don't apply to phone's
        matchmedia.onPhone( mediaQueryList => {
          if (mediaQueryList.matches && hasApplied) {
            element.css({
              width: '90%',
              left: 'auto',
              'padding-top': 'initial',
              'padding-bottom': 'initial'
            });
            hasApplied = false;
          } else if (!mediaQueryList.matches && !hasApplied) {
            element.css({
              width: (width - padding)+"px",
              left: -width+"px"
            });
            hasApplied = true;
            $timeout( () => {
              if (element[0].scrollWidth > element.outerWidth()) {
                element.css({
                  'padding-top': 0,
                  'padding-bottom': 0,
                  'white-space': 'normal'
                });
              }
            });
          }
        });

      }
    }
  });

  ngModule.directive('servicesFeatureList', () => {
    return {
      restrict: 'A',
      scope: {
        'servicesSelected': '=',
        'servicesList': '=',
        'featuresList': '=',
        'featureHeading': '@',
        'corporate': '=',
      },
      template: require("./services-feature-list.html"),
      link: (scope, element, attrs) => {
      }
    }
  });

  ngModule.directive('servicesFeatureListTable', (AonConfig) => {
    return {
      restrict: 'A',
      scope: {
        'servicesSelected': '=',
        'services': '=',
        'benefits': '=',
        'packages': '=',
        'features': '@',
        'servicesLabel': '@',
        'startOpen': '=',
        'corporate': '=',
      },
      template: require("./services-feature-list-table.html"),
      link: (scope, element, attrs) => {
        scope.open = scope.startOpen == true;
        scope.toggleShowing = () => {
          scope.open = !scope.open;
        }

        scope.showPerPerson = AonConfig.corporate.benefit_limits_show_per_person;
        scope.showPerPolicy = AonConfig.corporate.benefit_limits_show_per_policy;
        scope.showPerService = AonConfig.corporate.benefit_limits_show_per_service;

        scope.visibleServices = scope.services.filter(
          service => Boolean(service.selected) === scope.servicesSelected
        );

        const filterByService = (list, service) => {
          return list.filter(el => service.id === el.ancillary_service_id);
        }

        scope.getBenefits = (pkg, service) => {
          if (scope.features !== 'ancillary') {
            return '';
          }

          const value_rep = b => (b.benefit_type == "$" ? "$" : "") + b.benefit_payable + (b.benefit_type == "%" ? "%" : "");

          let benefits = filterByService(pkg.selectedPrice.productpriceancillaryservicebenefit_set, service);
          if (benefits.length) {
            return benefits.map(b => b.service_benefit + ":&nbsp;" + value_rep(b)).join("<br>").replace(/\s/g, "&nbsp;");
          } else {
            return "";
          }
        };
        scope.getLimits = (pkg, service) => {
          if (scope.features !== 'ancillary') {
            return '';
          }

          let limits = filterByService(pkg.selectedPrice.productpriceancillaryservicelimit_set, service);
          if (limits.length == 0) {
            return null;
          }
          limits = limits[0];
          if (limits &&
              limits.limit_per_person === null &&
              limits.limit_per_policy === null &&
              limits.limit_per_admission === null) {
            return null;
          }
          if (limits.limit_per_person != null) {
            limits.limit_per_person = parseInt(limits.limit_per_person);
          }
          if (limits.limit_per_policy != null) {
            limits.limit_per_policy = parseInt(limits.limit_per_policy);
          }
          if (limits.limit_per_service != null) {
            limits.limit_per_service = parseInt(limits.limit_per_service);
          }
          return limits;
        };
      }
    }
  });

}



// WEBPACK FOOTER //
// ./src/directives/feature-label.js